import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../../hooks/useLocalization';
import { FETCH_WORKFLOW_NAME } from './workflowBreadcrumb.query';

export const WorkflowBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { id } = useParams();
  const { data } = useQuery(FETCH_WORKFLOW_NAME, {
    variables: { workflowId: id ?? '' },
    skip: !id,
  });

  return translateBackendString(data?.fetchWorkflow?.workflow?.name);
};
